import React, {createContext, useContext, useReducer, useRef} from 'react'

export const SET_SEARCH_DATA = 'SET_SEARCH_DATA'
export const SET_ACTIVE_SEARCH_TAB = 'SET_ACTIVE_SEARCH_TAB'
export const SET_SELECTED_RECORD = 'SET_SELECTED_RECORD'
export const CLEAR_SELECTED_RECORD = 'CLEAR_SELECTED_RECORD'
export const SET_SEARCHING_STATUS = 'SET_SEARCHING_STATUS'
export const SET_CIRCUIT_PINS = 'SET_CIRCUIT_PINS'
export const RESET_CIRCUIT_PINS = 'RESET_CIRCUIT_PINS'
export const SET_CANDIDATE_CONNECTORS = 'SET_CANDIDATE_CONNECTORS'
export const SELECT_DESELECT_CANDIDATE = 'SELECT_DESELECT_CANDIDATE'
export const RESET_SELECTED_CANDIDATES = 'RESET_SELECTED_CANDIDATES'
export const SELECT_DESELECT_MAPPED = 'SELECT_DESELECT_MAPPED'
export const RESET_SELECTED_MAPPED = 'RESET_SELECTED_MAPPED'
export const SET_MAPPED_CONNECTORS = 'SET_MAPPED_CONNECTORS'
export const SET_FUNCTIONAL_DIAGRAM_DETAILS = 'SET_FUNCTIONAL_DIAGRAM_DETAILS'
export const SELECT_DESELECT_CONNECTOR_CATEGORIS =
  'SELECT_DESELECT_CONNECTOR_CATEGORIS'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_SEARCH_DATA: {
      return {
        ...data,
        searchData: payload.data,
        activeSearchTab: 'connectors',
        isSearching: false,
        selectedRecord: null,
        selectedCircuitPins: [],
        startConnectors: [],
        candidateConnectors: [],
        selectedCandidateIds: [],
        selectedConnectorCategories: [],
      }
    }
    case SET_ACTIVE_SEARCH_TAB: {
      return { ...data, activeSearchTab: payload.data }
    }
    case SET_SELECTED_RECORD: {
      return {
        ...data,
        selectedRecord: payload.data,
        selectedCircuitPins: [],
        startConnectors: [],
        candidateConnectors: [],
        selectedCandidateIds: [],
        selectedConnectorCategories: [],
      }
    }
    case CLEAR_SELECTED_RECORD: {
      return {
        ...data,
        selectedRecord: null,
        selectedCircuitPins: [],
        startConnectors: [],
        candidateConnectors: [],
        selectedCandidateIds: [],
        selectedConnectorCategories: [],
      }
    }
    case SET_SEARCHING_STATUS: {
      return { ...data, isSearching: payload.data }
    }
    case SET_CIRCUIT_PINS: {
      let selected_pins = [...data.selectedCircuitPins]
      if (selected_pins.includes(payload.data)) {
        selected_pins = selected_pins.filter((item) => item !== payload.data)
      } else {
        selected_pins.push(payload.data)
      }

      let tempStartConnectors = [...data.startConnectors]
      if (!tempStartConnectors.includes(payload.startConnectors)) {
        tempStartConnectors.push(payload.startConnectors)
      }
      return {
        ...data,
        selectedCircuitPins: selected_pins,
        startConnectors: tempStartConnectors,
      }
    }
    case RESET_CIRCUIT_PINS: {
      return {
        ...data,
        selectedCircuitPins: [],
        startConnectors: [],
        candidateConnectors: [],
        selectedCandidateIds: [],
        selectedConnectorCategories: [],
      }
    }
    case SET_CANDIDATE_CONNECTORS: {
      return {
        ...data,
        candidateConnectors: payload.data,
        selectedCandidateIds: [],
      }
    }
    case SELECT_DESELECT_CANDIDATE: {
      let selected = [...data.selectedCandidateIds]
      if (selected.includes(payload.data)) {
        selected = selected.filter((item) => item !== payload.data)
      } else {
        selected.push(payload.data)
      }
      return { ...data, selectedCandidateIds: selected }
    }
    case RESET_SELECTED_CANDIDATES: {
      return { ...data, selectedCandidateIds: [] }
    }
    case SELECT_DESELECT_MAPPED: {
      let selected = [...data.selectedMappedIds]
      if (selected.includes(payload.data)) {
        selected = selected.filter((item) => item !== payload.data)
      } else {
        selected.push(payload.data)
      }
      return { ...data, selectedMappedIds: selected }
    }
    case RESET_SELECTED_MAPPED: {
      return { ...data, selectedMappedIds: [] }
    }
    case SET_MAPPED_CONNECTORS: {
      return { ...data, mappedConnectors: payload.data }
    }
    case SET_FUNCTIONAL_DIAGRAM_DETAILS: {
      return {
        ...data,
        functionalDiagramDetails: payload.data,
        mappedConnectors: payload.mappedConnector,
        connectorCategories: payload.connectorCategories,
        selectedMappedIds: [],
        selectedCandidateIds: [],
      }
    }
    case SELECT_DESELECT_CONNECTOR_CATEGORIS: {
      let selected_connector_categories = [...data.selectedConnectorCategories]
      if (selected_connector_categories.includes(payload.data)) {
        selected_connector_categories = selected_connector_categories.filter(
          (item) => item !== payload.data
        )
      } else {
        selected_connector_categories.push(payload.data)
      }
      return {
        ...data,
        selectedConnectorCategories: selected_connector_categories,
      }
    }
    default: {
      return data
    }
  }
}

const initialState = {
  searchQuery: '',
  isSearching: false,
  searchData: { connectors: [], devices: [], circuits: [] },
  activeSearchTab: 'connectors',
  selectedRecord: null,
  selectedCircuitPins: [],
  startConnectors: [],

  candidateConnectors: [],
  selectedCandidateIds: [],
  connectorCategories: [],
  selectedConnectorCategories: [],

  mappedConnectors: [],
  selectedMappedIds: [],

  functionalDiagramDetails: {},
}

const shallowEqual = (a, b) => {
  if (a === b) return true
  const keysA = Object.keys(a)
  if (keysA.length !== Object.keys(b).length) return false
  for (let i = 0; i < keysA.length; i++) {
    const key = keysA[i]
    if (a[key] !== b[key]) return false
  }
  return true
}

const useShallowMemo = (factory, deps) => {
  const ref = useRef()
  const depsRef = useRef()

  if (ref.current === undefined || !shallowEqual(depsRef.current, deps)) {
    depsRef.current = deps
    ref.current = factory()
  }

  return ref.current
}

const searchSelector = (s) => ({
  searchData: s.searchData,
  activeSearchTab: s.activeSearchTab,
  selectedRecord: s.selectedRecord,
  selectedCircuitPins: s.selectedCircuitPins,
  startConnectors: s.startConnectors,
  isSearching: s.isSearching,
})

const candidateSelector = (s) => ({
  candidateConnectors: s.candidateConnectors,
  selectedCandidateIds: s.selectedCandidateIds,
  connectorCategories: s.connectorCategories,
  selectedConnectorCategories: s.selectedConnectorCategories,
  mappedConnectors: s.mappedConnectors,
  selectedRecord: s.selectedRecord,
  selectedCircuitPins: s.selectedCircuitPins,
})

const mappedSelector = (s) => ({
  mappedConnectors: s.mappedConnectors,
  selectedMappedIds: s.selectedMappedIds,
})

const pageSelector = (s) => ({
  functionalDiagramDetails: s.functionalDiagramDetails,
})

const SearchContext = createContext([searchSelector(initialState), () => {}])
const CandidateContext = createContext([candidateSelector(initialState), () => {}])
const MappedContext = createContext([mappedSelector(initialState), () => {}])
const PageContext = createContext([pageSelector(initialState), () => {}])

const FunctionalDiagramEditStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  const searchValue = useShallowMemo(
    () => [searchSelector(state), dispatch],
    [searchSelector(state), dispatch]
  )

  const candidateValue = useShallowMemo(
    () => [candidateSelector(state), dispatch],
    [candidateSelector(state), dispatch]
  )

  const mappedValue = useShallowMemo(
    () => [mappedSelector(state), dispatch],
    [mappedSelector(state), dispatch]
  )

  const pageValue = useShallowMemo(
    () => [pageSelector(state), dispatch],
    [pageSelector(state), dispatch]
  )

  return (
    <PageContext.Provider value={pageValue}>
      <SearchContext.Provider value={searchValue}>
        <CandidateContext.Provider value={candidateValue}>
          <MappedContext.Provider value={mappedValue}>
            {children}
          </MappedContext.Provider>
        </CandidateContext.Provider>
      </SearchContext.Provider>
    </PageContext.Provider>
  )
}

export const useSearchContext = () => useContext(SearchContext)
export const useCandidateContext = () => useContext(CandidateContext)
export const useMappedContext = () => useContext(MappedContext)
export const usePageContext = () => useContext(PageContext)

export {
  SearchContext,
  CandidateContext,
  MappedContext,
  PageContext,
}

export default FunctionalDiagramEditStore
